module.exports = __webpack_public_path__ + "static/media/Sonu Modi.814388d1.webp";